import React, {useEffect, useRef, useState} from 'react';
import {batch, useDispatch, useSelector} from "react-redux";
import "../AccountSettings/AccountSettings.scss"
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import { useLocation, Navigate } from 'react-router-dom'
import Exporter from "./Exporter";

const Tools = (props) => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const [tabIndex, setTabIndex] = useState(0);
    const {hash: locationHash} = useLocation()

    useEffect(()=>{
        let tabs = ['exporter']
        const tab_id = tabs.indexOf(locationHash.replace('#',''))
        if(tab_id !==-1){
            setTabIndex(tab_id)
        }else{
            setTabIndex(0)
        }
    },[locationHash])

    return (
        <>
            <div className="mb-4 mt-2">
                <h4>
                    Tools
                </h4>
            </div>
            <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)} className="rect-tabs pt-2">
                <TabList>
                    <Tab>Exporter</Tab>
                </TabList>
                    <Exporter signed_in={props.signed_in}/>
                <TabPanel>

                </TabPanel>


            </Tabs>
        </>
    )
}

export default React.memo(Tools)